<template>
    <div class="main">
        <c-panel :title="modoEdicao ? 'EDITAR MATERIAL' : 'NOVO MATERIAL'" titleIcon="fas fa-folder-open">
            <el-form label-position="top" :model="form" ref="formRef" @submit.native.prevent="salvar">

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24">
                        <el-form-item label="Título" prop="titulo" :rules="[$requiredBlur]">
                            <el-input v-model="form.titulo" maxlength="255" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="14">
                        <el-form-item label="Turma" prop="turma_id" :rules="[$requiredChange]">
                            <el-select v-model="form.turma_id" filterable style="width:100%;">
                                <el-option v-for="t in turmas" :key="t.id" :label="`${t.curso ? t.curso.nome + ' ' : ''}${t.nome}`" :value="t.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="5">
                        <el-form-item label="Liberar em">
                            <el-date-picker v-model="form.data_liberacao" type="datetime" format="dd/MM/yyyy HH:mm" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%;"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="5">
                        <el-form-item label="Prazo limite (opcional)">
                            <el-date-picker v-model="form.data_limite" type="datetime" format="dd/MM/yyyy HH:mm" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%;"></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24">
                        <el-form-item label="Descrição">
                            <el-input type="textarea" v-model="form.descricao" :rows="3"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="12" :sm="12">
                        <el-form-item label="Requer devolução do aluno?">
                            <el-select v-model="form.requer_retorno" style="width:100%;">
                                <el-option :value="true" label="SIM"></el-option>
                                <el-option :value="false" label="NÃO"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12">
                        <el-form-item label="Publicado">
                            <el-select v-model="form.publicado" style="width:100%;">
                                <el-option :value="true" label="SIM"></el-option>
                                <el-option :value="false" label="RASCUNHO"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24">
                        <el-form-item label="Tipo" prop="tipo" :rules="[$requiredChange]">
                            <el-select v-model="form.tipo" style="width:100%;">
                                <el-option :value="1" label="ARQUIVO (UPLOAD)"></el-option>
                                <el-option :value="2" label="VÍDEO (URL OU EMBED)"></el-option>
                                <el-option :value="3" label="LINK EXTERNO"></el-option>
                                <el-option :value="4" label="AVISO/TEXTO"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <!-- Arquivo -->
                <el-form-item v-if="form.tipo === 1">
                    <el-upload
                        :action="`${baseUrl()}/api/material-turma/uploadArquivo`"
                        name="arquivo"
                        :headers="{ Authorization: 'Bearer ' + token() }"
                        :on-success="onUploadSuccess"
                        :on-error="onUploadError"
                        :before-upload="beforeUpload"
                        :limit="1">
                        <el-button type="primary" icon="el-icon-upload">SELECIONAR ARQUIVO</el-button>
                        <div v-if="form.caminho" style="margin-top:8pt; color:#67c23a;">
                            <i class="el-icon-document"></i> {{ form.caminho_nome || form.caminho }}
                        </div>
                    </el-upload>
                </el-form-item>

                <!-- Vídeo / Link -->
                <el-form-item v-if="form.tipo === 2 || form.tipo === 3" :label="form.tipo === 2 ? 'URL do vídeo OU código de incorporação (iframe)' : 'URL externa'">
                    <el-input type="textarea" v-model="form.url_video" :rows="form.tipo === 2 ? 3 : 1" placeholder="https://youtube.com/watch?v=... ou <iframe ...></iframe>"></el-input>
                </el-form-item>

                <el-row class="u-mt-15">
                    <el-col :xs="24" class="u-text-right">
                        <router-link to="/admin/material-turma"><el-button>VOLTAR</el-button></router-link>
                        <el-button class="u-ml-10" type="primary" native-type="submit">SALVAR</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </c-panel>
    </div>
</template>

<script>
export default {
    data () {
        return {
            form: this.formVazio(),
            modoEdicao: false,
            turmas: [],
            tamanhoMaxKb: null
        }
    },
    mounted () {
        this.carregarTurmas()
        this.carregarLimiteUpload()
        if (this.$route.params.id) {
            this.modoEdicao = true
            this.carregar(this.$route.params.id)
        } else {
            this.form.instituicao_id = this.instituicaoId()
        }
    },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },
        instituicaoId () { const i = this.$store.state.config.instituicao; return i && i.id ? i.id : null },
        token () { return this.$store.state.token },

        formVazio () {
            return {
                turma_id: null, instituicao_id: null, disciplina_id: null,
                titulo: '', descricao: '', tipo: 1,
                caminho: '', caminho_nome: '', caminho_mime: '', caminho_size: null,
                url_video: '',
                data_liberacao: null, data_limite: null,
                requer_retorno: false, publicado: true
            }
        },
        carregar (id) {
            this.$axios.get(`${this.baseUrl()}/api/material-turma/getById/${id}`, this.$store.getters.getHeaderAuth).then(r => {
                const reg = r.data || {}
                Object.keys(this.form).forEach(k => { if (reg[k] !== undefined && reg[k] !== null) this.form[k] = reg[k] })
            })
        },
        carregarTurmas () {
            const i = this.instituicaoId()
            const p = this.$store.state.config.periodo ? this.$store.state.config.periodo.id : null
            if (!i || !p) { this.turmas = []; return }
            this.$axios.get(`${this.baseUrl()}/api/turma/getTurmasForListDiario/${i}/${p}`, this.$store.getters.getHeaderAuth)
                .then(r => {
                    // getTurmasForListDiario retorna agrupado por curso ({ "CURSO": [turmas...] }); achata em lista única.
                    const grupos = r.data || {}
                    const lista = []
                    Object.keys(grupos).forEach(c => (grupos[c] || []).forEach(t => lista.push(t)))
                    this.turmas = lista
                })
                .catch(() => { this.turmas = [] })
        },
        carregarLimiteUpload () {
            this.$axios.get(`${this.baseUrl()}/api/parametro-sistema/getValor/upload.tamanho_max_material_kb`, this.$store.getters.getHeaderAuth)
                .then(r => { this.tamanhoMaxKb = r.data && r.data.valor ? Number(r.data.valor) : null })
                .catch(() => { this.tamanhoMaxKb = null })
        },
        formatarTamanhoKb (kb) {
            if (!kb) return ''
            return kb >= 1024 ? (kb / 1024).toFixed(kb % 1024 === 0 ? 0 : 1) + ' MB' : kb + ' KB'
        },
        beforeUpload (file) {
            if (this.tamanhoMaxKb && file.size > this.tamanhoMaxKb * 1024) {
                window.eventBus.$emit('alert', { msg: `Arquivo excede o tamanho máximo permitido de ${this.formatarTamanhoKb(this.tamanhoMaxKb)}.`, type: 'warning' })
                return false
            }
            this.form.caminho_nome = file.name
            this.form.caminho_mime = file.type
            this.form.caminho_size = file.size
            return true
        },
        onUploadSuccess (res) {
            if (res && res.erro) {
                window.eventBus.$emit('alert', { msg: typeof res.erro === 'string' ? res.erro : res.erro.text, type: 'warning' })
                return
            }
            if (res && res.caminho) {
                this.form.caminho = res.caminho
                this.form.caminho_nome = res.caminho_nome
                this.form.caminho_mime = res.caminho_mime
                this.form.caminho_size = res.caminho_size
                window.eventBus.$emit('alert', { msg: 'Arquivo enviado.', type: 'success' })
            }
        },
        onUploadError () {
            window.eventBus.$emit('alert', { msg: 'Erro no upload do arquivo.', type: 'error' })
        },

        salvar () {
            this.$refs.formRef.validate(valid => {
                if (!valid) { window.eventBus.$emit('alert', { msg: 'Preencha os campos obrigatórios.', type: 'warning' }); return }
                const url = this.modoEdicao
                    ? `${this.baseUrl()}/api/material-turma/update/${this.$route.params.id}`
                    : `${this.baseUrl()}/api/material-turma/store`
                this.$axios.post(url, this.form, this.$store.getters.getHeaderAuth).then(r => {
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                        return
                    }
                    window.eventBus.$emit('alert', { msg: 'Material salvo. Alunos da turma serão notificados.', type: 'success' })
                    this.$router.push('/admin/material-turma')
                })
            })
        }
    }
}
</script>
